<div class="d-flex actions-wrapper">
  <div
    *ngIf="hasReplenishment$ | async"
    class="px-2 d-inline-flex"
    atxTooltip="In the replenishment"
    i18n-atxTooltip="
      Product card|replenishment replenishment text@@preplenishmentIndicatorText"
    tooltipPlacement="top"
  >
    <fa-icon [icon]="['fas', 'repeat']" class="text-primary"></fa-icon>
  </div>

  <button
    type="button"
    class="px-2 btn"
    atxTooltip="Preview selected variant"
    i18n-atxTooltip="
      Product card|preview media gallery text@@previeMediaGalleryText"
    tooltipPlacement="top"
    [atxMediaLightbox]="currentVariantMedia"
    [atxMediaAsideContent]="previewAttributes ? attributes : null"
  >
    <fa-icon
      [icon]="['fas', 'eye']"
      data-e2e="btn-preview-product-gallery"
      class="p-card-icon"
    ></fa-icon>
  </button>

  <ng-container *ngIf="!deletable; else deleteFromList">
    @if (showBookmarkIcon) {
    <atx-bookmark-button
      [showAddBookmarkButton]="!addedToActiveList"
      [isBookmarking]="isBookmarking"
      (addBookmarkClicked)="onAddProductToActiveList()"
      (removeBookmarkClicked)="onRemoveProductFromActiveList()"
      class="pl-2 pr-0"
      [class.remove-from-list]="addedToActiveList"
    ></atx-bookmark-button>
    }
  </ng-container>

  <ng-template #deleteFromList>
    <button
      type="button"
      class="pl-2 pr-0 btn"
      (click)="onDeleteFromProductList(); $event.stopPropagation()"
      atxTooltip="Delete from list"
      i18n-atxTooltip="
        Product card|delete from list button tooltip text@@deleteFromList"
      tooltipPlacement="top"
    >
      <fa-icon
        [icon]="['fas', 'trash']"
        data-e2e="delete-product-from-list"
        class="p-card-icon"
      ></fa-icon>
    </button>
  </ng-template>
</div>

<ng-template #attributes>
  <atx-attributes-panel
    [componentDef]="panelDef$ | async"
    [data]="product$ | async"
  ></atx-attributes-panel>
</ng-template>
